import gql from "graphql-tag";

export const SIMPLE_COACHES_QUERY = gql`
  query simpleCoaches($coachId: ID, $includeCurrentCoach: Boolean) {
    simpleCoaches(coachId: $coachId, includeCurrentCoach: $includeCurrentCoach) {
      id
      firstName
      lastName
    }
  }
`;

export const SIMPLE_CLIENTS_QUERY = gql`
  query simpleClients($coachId: ID) {
    simpleClients(coachId: $coachId) {
      id
      firstName
      lastName
    }
  }
`;

export const SECONDARY_USERS_QUERY = gql`
  query secondaryCoachUsers($periodId: ID!) {
    secondaryCoachUsers(periodId: $periodId) {
      coach {
        id
        firstName
        lastName
      }
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

export const UPSERT_SECONDARY_COACH_MUTATION = gql`
  mutation upsertSecondaryCoach(
    $startDate: Date!
    $endDate: Date!
    $inputs: [SecondaryCoachInput]!
    $secondaryCoachPeriodId: ID
    $coachId: ID
    $outOfOffice: String
  ) {
    upsertSecondaryCoach(
      startDate: $startDate
      endDate: $endDate
      inputs: $inputs
      secondaryCoachPeriodId: $secondaryCoachPeriodId
      coachId: $coachId
      outOfOffice: $outOfOffice
    ) {
      success
    }
  }
`;

export const ACTIVE_SECONDARY_COACHING_PERIODS = gql`
  query secondaryCoachingPeriods($coachId: ID) {
    secondaryCoachingPeriods(activePeriod: true, coachId: $coachId) {
      id
      coachsecondaryuserprogramSet {
        edges {
          node {
            id
            secondaryCoach {
              id
              firstName
              lastName
            }
            userProgram {
              id
              user {
                id
                firstName
                lastName
              }
            }
            subscription {
              id
              user {
                id
                firstName
                lastName
              }
            }
            addedToWhatsapp
          }
        }
      }
      startDate
      endDate
    }

    users(isActive: true, isStaff: true) {
      edges {
        node {
          id
          firstName
          lastName
          email
          isStaff
          isActive
        }
      }
    }
  }
`;

export const UPDATE_SECONDARY_COACH_MUTATION = gql`
  mutation updateSecondaryCoach($secondaryCoachId: ID!, $coachId: ID, $addedToWhatsApp: Boolean) {
    updateSecondaryCoach(secondaryCoachId: $secondaryCoachId, coachId: $coachId, addedToWhatsApp: $addedToWhatsApp) {
      success
      error
    }
  }
`;
